export var FundsHouseMapper = function (data) {
    var fundsHouseEntity = {
        mutualFundsList: [],
    };
    if (data && data.length > 0) {
        fundsHouseEntity.mutualFundsList = data.map(function (record) {
            return {
                fundsHouseName: record.amcName,
                isPopular: record.isPopular === "1" ? true : false,
                fundsHouseId: record.id,
            };
        });
    }
    return fundsHouseEntity;
};
